import React, {Component, createRef} from 'react';
import '../../../../style/profilePage.css'
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import BuildingContext from "../../../../contexts/Building";
import Accordion from 'react-bootstrap/Accordion';
import {RiDownloadCloud2Fill} from "react-icons/ri";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import axios from "axios";
import { API_BASE_URL } from '../../../../api/client';
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import { formatDateObject } from '../../../../utils/persianDate';

class PersonnelProfilePage extends Component {

    static contextType = BuildingContext;

    state = {
        personnel: {},
        show: false,
        reportType: 'cleaning',
        personnelObject: {},
        showDeleteModalReport: false,
        docFile: {},
        fileDetails: [],
        profileImgUrl: null,
        hasBirthPage1: false,
        hasBirthPage2: false,
        hasBirthPage3: false,
        hasBirthPage4: false,
        hasBirthAllPage: false,
        hasCartPage1: false,
        hasCartPage2: false,
        hasCartAllPage: false,
        hasPersonnelImg: false,
        hasContract: false,
        registerLoading: false,
        workTasks: [],
        workReportText: '',
        workReportDate: '',
        workReportLoading: false,
        editingWorkTask: null,
        personnelHistory: [],
        historyRecordType: 'personnelEntry',
        historyDate: '',
        historyDescription: '',
        editDraft: {},
        showEditForm: false,
        editSaving: false,
        cleaningArchiveSearch: '',
    }
    date = createRef();
    description = createRef();
    time = createRef();
    startDate = createRef();
    endDate = createRef();
    destinationAddress = createRef();
    destinationPhoneNumber = createRef();
    relation = createRef();

    reason = createRef();
    penaltyAmount = createRef();

    async componentDidMount() {
        let parentId = ""
        let profileId = ""
        const personnelId = window.location.href.slice(-32)
        await axios.get(`${API_BASE_URL}/api/v1/supervisor/characteristic/${personnelId}`, {headers: {'Authorization': localStorage.getItem('accessToken')}}).then(response => response.data)
            .then((data) => {
                this.setState({
                    personnel: data,
                    editDraft: {...data},
                })
                parentId = data.parentId;
                profileId = data.profileId
            }).catch(async () => {
                if (localStorage.getItem('role') === 'MANAGER') {
                    await axios.get(`${API_BASE_URL}/api/v1/manager/token/refresh`, {headers: {'Authorization': localStorage.getItem('refreshToken')}})
                        .then(async (response) => {
                            if (response.headers["accesstoken"]) {
                                localStorage.setItem("accessToken", response.headers["accesstoken"]);
                                await axios.get(`${API_BASE_URL}/api/v1/supervisor/characteristic/${personnelId}`, {headers: {'Authorization': localStorage.getItem('accessToken')}}).then(response => response.data)
                                    .then((data) => {
                                        this.setState({
                                            personnel: data,
                                        })
                                        parentId = data.parentId;
                                        profileId = data.profileId
                                    })
                            } else {
                                window.location = '/'
                            }
                        })
                } else if (localStorage.getItem('role') === 'SUPERVISOR') {
                    await axios.get(`${API_BASE_URL}/api/v1/supervisor/token/refresh`, {headers: {'Authorization': localStorage.getItem('refreshToken')}})
                        .then(async (response) => {
                            if (response.headers["accesstoken"]) {
                                localStorage.setItem("accessToken", response.headers["accesstoken"]);
                                await axios.get(`${API_BASE_URL}/api/v1/supervisor/characteristic/${personnelId}`,
                                    {
                                        headers: {
                                            'Authorization': localStorage.getItem('accessToken'),
                                            'Access-Control-Allow-Origin': '*'
                                        }
                                    }).then(response => response.data)
                                    .then((data) => {
                                        this.setState({
                                            personnel: data,
                                        })
                                        parentId = data.parentId;
                                        profileId = data.profileId
                                    })
                            } else {
                                window.location = '/'
                            }
                        })
                }
            })

        await axios.get(`${API_BASE_URL}/api/v1/supervisor/personnel/${parentId}`, {headers: {'Authorization': localStorage.getItem('accessToken')}}).then(response => response.data)
            .then(async (data) => {
                this.setState({personnelObject: data});
                await this.loadWorkTasks(data.id);
                await this.loadPersonnelHistory(data.id);
            }).catch(async () => {
                if (localStorage.getItem('role') === 'MANAGER') {
                    await axios.get(`${API_BASE_URL}/api/v1/manager/token/refresh`, {headers: {'Authorization': localStorage.getItem('refreshToken')}})
                        .then(async (response) => {
                            if (response.headers["accesstoken"]) {
                                localStorage.setItem("accessToken", response.headers["accesstoken"]);
                                await axios.get(`${API_BASE_URL}/api/v1/supervisor/personnel/${parentId}`, {headers: {'Authorization': localStorage.getItem('accessToken')}}).then(response => response.data)
                                    .then(async (data) => {
                                        this.setState({personnelObject: data});
                                        await this.loadWorkTasks(data.id);
                                    })
                            } else {
                                window.location = '/'
                            }
                        })
                } else if (localStorage.getItem('role') === 'SUPERVISOR') {
                    await axios.get(`${API_BASE_URL}/api/v1/supervisor/token/refresh`, {headers: {'Authorization': localStorage.getItem('refreshToken')}})
                        .then(async (response) => {
                            if (response.headers["accesstoken"]) {
                                localStorage.setItem("accessToken", response.headers["accesstoken"]);
                                await axios.get(`${API_BASE_URL}/api/v1/supervisor/personnel/${parentId}`,
                                    {
                                        headers: {
                                            'Authorization': localStorage.getItem('accessToken'),
                                            'Access-Control-Allow-Origin': '*'
                                        }
                                    }).then(response => response.data)
                                    .then(async (data) => {
                                        this.setState({personnelObject: data});
                                        await this.loadWorkTasks(data.id);
                                    })
                            } else {
                                window.location = '/'
                            }
                        })
                }
            })

        if (this.state.personnel.profileId !== null) {
            await axios.get(API_BASE_URL + "/api/v1/supervisor/file/" + profileId, {responseType: "blob", headers: {Authorization: localStorage.getItem("accessToken")}}).then(response => response.data)
                .then((data) => {
                const objectUrl = URL.createObjectURL(data);
                this.setState({profileImgUrl: objectUrl})
            }).catch(async () => {
                    if (localStorage.getItem('role') === 'MANAGER') {
                        await axios.get(`${API_BASE_URL}/api/v1/manager/token/refresh`, {headers: {'Authorization': localStorage.getItem('refreshToken')}})
                            .then(async (response) => {
                                if (response.headers["accesstoken"]) {
                                    localStorage.setItem("accessToken", response.headers["accesstoken"]);
                                    await axios.get(`${API_BASE_URL}/api/v1/supervisor/file/${profileId}`, {
                                        responseType: "blob",
                                        headers: {'Authorization': localStorage.getItem('accessToken')}
                                    }).then(response => response.data)
                                        .then((data) => {
                                            const objectUrl = URL.createObjectURL(data);
                                            this.setState({profileImgUrl: objectUrl})
                                        })
                                } else {
                                    window.location = '/'
                                }
                            })
                    } else if (localStorage.getItem('role') === 'SUPERVISOR') {
                        await axios.get(`${API_BASE_URL}/api/v1/supervisor/token/refresh`, {headers: {'Authorization': localStorage.getItem('refreshToken')}})
                            .then(async (response) => {
                                if (response.headers["accesstoken"]) {
                                    localStorage.setItem("accessToken", response.headers["accesstoken"]);
                                    await axios.get(`${API_BASE_URL}/api/v1/supervisor/file/${profileId}`, {
                                        responseType: "blob",
                                        headers: {'Authorization': localStorage.getItem('accessToken')}
                                    }).then(response => response.data)
                                        .then((data) => {
                                            const objectUrl = URL.createObjectURL(data);
                                            this.setState({profileImgUrl: objectUrl})
                                        })
                                } else {
                                    window.location = '/'
                                }
                            })
                    }
                })
        }


        await axios.get(`${API_BASE_URL}/api/v1/supervisor/responseFile/search?parentType=Personnel&parentId=${parentId}`, {headers: {'Authorization': localStorage.getItem('accessToken')}}).then(response => response.data)
            .then((data) => this.setState({fileDetails: data}, () => {
                this.setState({docFile: this.state.personnelObject.files, report: this.state.personnelObject.record}, () => {
                    this.existDocFile(this.state.personnelObject.files);
                });
            }))
            .catch(async () => {
                if (localStorage.getItem('role') === 'MANAGER') {
                    await axios.get(`${API_BASE_URL}/api/v1/manager/token/refresh`, {headers: {'Authorization': localStorage.getItem('refreshToken')}})
                        .then(async (response) => {
                            if (response.headers["accesstoken"]) {
                                localStorage.setItem("accessToken", response.headers["accesstoken"]);
                                await axios.get(`${API_BASE_URL}/api/v1/supervisor/responseFile/search?parentType=Personnel&parentId=${parentId}`, {headers: {'Authorization': localStorage.getItem('accessToken')}}).then(response => response.data)
                                    .then((data) => this.setState({fileDetails: data}, () => {
                                        this.setState({
                                            docFile: this.state.personnelObject.files,
                                            report: this.state.personnelObject.record
                                        }, () => {
                                            console.log(123, this.state.personnelObject, this.state.personnel)
                                            this.existDocFile(this.state.personnelObject.files);
                                        });
                                    }))
                            } else {
                                window.location = '/'
                            }
                        })
                } else if (localStorage.getItem('role') === 'SUPERVISOR') {
                    await axios.get(`${API_BASE_URL}/api/v1/supervisor/token/refresh`, {headers: {'Authorization': localStorage.getItem('refreshToken')}})
                        .then(async (response) => {
                            if (response.headers["accesstoken"]) {
                                localStorage.setItem("accessToken", response.headers["accesstoken"]);
                                await axios.get(`${API_BASE_URL}/api/v1/supervisor/responseFile/search?parentType=Personnel&parentId=${parentId}`, {headers: {'Authorization': localStorage.getItem('accessToken')}}).then(response => response.data)
                                    .then((data) => this.setState({fileDetails: data}, () => {
                                        this.setState({
                                            docFile: this.state.personnelObject.files,
                                            report: this.state.personnelObject.record
                                        }, () => {
                                            console.log(123, this.state.personnelObject, this.state.personnel)
                                            this.existDocFile(this.state.personnelObject.files);
                                        });
                                    }))
                            } else {
                                window.location = '/'
                            }
                        })
                }
            })
    }

    render() {
        return (
            <>
                <div className="px-3 mb-5">
                    <div className="d-flex flex-column container">
                        <div className="d-flex flex-row justify-content-center profile-card">
                            <div className={'d-flex flex-md-row flex-column align-items-center'}>
                                <img
                                    src={this.state.profileImgUrl !== null ? (this.state.profileImgUrl) : ("https://cdn-icons-png.flaticon.com/512/149/149071.png")}
                                    alt="profile"/>
                                <div className={'me-3 d-flex flex-column justify-content-center'}>
                                    <div
                                        className="people-name mb-3">{this.state.personnel.firstName} {this.state.personnel.lastName}</div>
                                    <div className="d-flex flex-md-row flex-column flex-wrap">
                                        <div className="people-item"><i className="bi bi-upc-scan ms-2"></i>کد
                                            ملی: {this.state.personnel.nationalCode}</div>
                                        <div className="people-item"><i className="bi bi-telephone ms-2"></i>شماره
                                            تماس: {this.state.personnel.phoneNumber}</div>
                                        <div className="people-item"><i className="bi bi-personnel ms-2"></i>نام
                                            پدر: {this.state.personnel.fatherName}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="tab">
                            <Tabs
                                defaultActiveKey="more-information"
                                id="uncontrolled-tab-example"
                                className="border-0 w-100"
                            >
                                <Tab eventKey="more-information" title="اطلاعات بیشتر"
                                     style={{backgroundColor: "transparent"}}>
                                    <div className="tabs-content">
                                        <div className="information d-flex flex-row flex-wrap">
                                            <div className='col-12 col-md-4'>
                                                <div className="more-info-item">
                                                    <i className="bi bi-caret-left ms-1"></i>
                                                    <label> نام :</label>
                                                    {this.state.personnel.firstName}
                                                </div>
                                            </div>
                                            <div className='col-12 col-md-4'>
                                                <div className="more-info-item">
                                                    <i className="bi bi-caret-left ms-1"></i>
                                                    <label> نام خانوادگی :</label>
                                                    {this.state.personnel.lastName}
                                                </div>
                                            </div>
                                            <div className='col-12 col-md-4'>
                                                <div className="more-info-item">
                                                    <i className="bi bi-caret-left ms-1"></i>
                                                    <label> کد ملی :</label>
                                                    {this.state.personnel.nationalCode}
                                                </div>
                                            </div>
                                            <div className='col-12 col-md-4'>
                                                <div className="more-info-item">
                                                    <i className="bi bi-caret-left ms-1"></i>
                                                    <label> شماره شناسنامه :</label>
                                                    {this.state.personnel.certificateNumber}
                                                </div>
                                            </div>
                                            <div className='col-12 col-md-4'>
                                                <div className="more-info-item">
                                                    <i className="bi bi-caret-left ms-1"></i>
                                                    <label> محل صدور :</label>
                                                    {this.state.personnel.placeOfIssue}
                                                </div>
                                            </div>
                                            <div className='col-12 col-md-4'>
                                                <div className="more-info-item">
                                                    <i className="bi bi-caret-left ms-1"></i>
                                                    <label> تاریخ تولد :</label>
                                                    {this.state.personnel.birthDate}
                                                </div>
                                            </div>
                                            <div className='col-12 col-md-4'>
                                                <div className="more-info-item">
                                                    <i className="bi bi-caret-left ms-1"></i>
                                                    <label> محل تولد :</label>
                                                    {this.state.personnel.birthPlace}
                                                </div>
                                            </div>
                                            <div className='col-12 col-md-4'>
                                                <div className="more-info-item">
                                                    <i className="bi bi-caret-left ms-1"></i>
                                                    <label> ملیت :</label>
                                                    {this.state.personnel.nationality}
                                                </div>
                                            </div>
                                            <div className='col-12 col-md-4'>
                                                <div className="more-info-item">
                                                    <i className="bi bi-caret-left ms-1"></i>
                                                    <label> دین :</label>
                                                    {(() => {
                                                        switch (this.state.personnel.religion) {
                                                            case 'islam':
                                                                return 'اسلام';
                                                            case 'christianity':
                                                                return 'مسیحیت';
                                                            case 'hinduism':
                                                                return 'هندوئیسم';
                                                            case 'buddhism':
                                                                return 'آیین بودایی';
                                                            case 'other':
                                                                return 'سایر';
                                                        }
                                                    })()}
                                                </div>
                                            </div>
                                            <div className='col-12 col-md-4'>
                                                <div className="more-info-item">
                                                    <i className="bi bi-caret-left ms-1"></i>
                                                    <label> مذهب :</label>
                                                    {this.state.personnel.subReligion !== "" ? this.state.personnel.subReligion : 'ثبت نشده'}
                                                </div>
                                            </div>
                                            <div className='col-12 col-md-4'>
                                                <div className="more-info-item">
                                                    <i className="bi bi-caret-left ms-1"></i>
                                                    <label> وضعیت تاهل :</label>
                                                    {(() => {
                                                        switch (this.state.personnel.maritalStatus) {
                                                            case 'single':
                                                                return 'مجرد';
                                                            case 'married':
                                                                return 'متاهل';
                                                            case 'divorced':
                                                                return 'متارکه';
                                                        }
                                                    })()}
                                                </div>
                                            </div>
                                            {(() => {
                                                switch (this.state.personnel.maritalStatus) {
                                                    case 'married':
                                                        return (
                                                        <>
                                                            <div className='col-12 col-md-4'>
                                                                <div className="more-info-item">
                                                                    <i className="bi bi-caret-left ms-1"></i>
                                                                    <label> نام و نام خانوادگی همسر
                                                                        :</label>
                                                                    {this.state.personnel.spouseFullName !== "" ? this.state.personnel.spouseFullName : 'ثبت نشده'}
                                                                </div>
                                                            </div>
                                                            <div className='col-12 col-md-4'>
                                                                <div className="more-info-item">
                                                                    <i className="bi bi-caret-left ms-1"></i>
                                                                    <label> شغل همسر :</label>
                                                                    {this.state.personnel.spouseJob !== "" ? this.state.personnel.spouseJob : 'ثبت نشده'}
                                                                </div>
                                                            </div>
                                                        </>);
                                                }
                                            })()}
                                            <div className='col-12 col-md-4'>
                                                <div className="more-info-item">
                                                    <i className="bi bi-caret-left ms-1"></i>
                                                    <label> بیماری خاص :</label>
                                                    {(() => {
                                                        switch (this.state.personnel.health) {
                                                            case true:
                                                                return 'بله';
                                                            case false:
                                                                return 'خیر';
                                                        }
                                                    })()}
                                                </div>
                                            </div>
                                            {(() => {
                                                switch (this.state.personnel.health) {
                                                    case true:
                                                        return <>
                                                            <div className='col-12 col-md-4'>
                                                                <div className="more-info-item">
                                                                    <i className="bi bi-caret-left ms-1"></i>
                                                                    <label> توضیحات بیماری :</label>
                                                                    {this.state.personnel.healthyStatus !== "" ? this.state.personnel.healthyStatus : 'ثبت نشده'}
                                                                </div>
                                                            </div>
                                                        </>;
                                                }
                                            })()}
                                            <div className='col-12 col-md-4'>
                                                <div className="more-info-item">
                                                    <i className="bi bi-caret-left ms-1"></i>
                                                    <label> تلفن ثابت :</label>
                                                    {this.state.personnel.telephoneNumber}
                                                </div>
                                            </div>
                                            <div className='col-12 col-md-4'>
                                                <div className="more-info-item">
                                                    <i className="bi bi-caret-left ms-1"></i>
                                                    <label> تلفن اضطراری :</label>
                                                    {this.state.personnel.emergencyNumber}
                                                </div>
                                            </div>
                                            <div className='col-12 col-md-4'>
                                                <div className="more-info-item">
                                                    <i className="bi bi-caret-left ms-1"></i>
                                                    <label> تاریخ عقد قرارداد :</label>
                                                    {this.state.personnel.timePeriod?.startDate}
                                                </div>
                                            </div>
                                            <div className='col-12 col-md-4'>
                                                <div className="more-info-item">
                                                    <i className="bi bi-caret-left ms-1"></i>
                                                    <label> تاریخ اتمام قرارداد :</label>
                                                    {this.state.personnel.timePeriod?.endDate}
                                                </div>
                                            </div>
                                            <div className='col-12 col-md-4'>
                                                <div className="more-info-item">
                                                    <i className="bi bi-caret-left ms-1"></i>
                                                    <label> آدرس محل سکونت :</label>
                                                    {this.state.personnel.address}
                                                </div>
                                            </div>
                                            <div className='col-12 col-md-4'>
                                                <div className="more-info-item">
                                                    <i className="bi bi-caret-left ms-1"></i>
                                                    <label> تحصیلات :</label>
                                                    {this.state.personnel.education !== "" ? this.state.personnel.education : 'ثبت نشده'}
                                                </div>
                                            </div>
                                            <div className='col-12 col-md-4'>
                                                <div className="more-info-item">
                                                    <i className="bi bi-caret-left ms-1"></i>
                                                    <label> دانشگاه :</label>
                                                    {this.state.personnel.university !== "" ? this.state.personnel.university : 'ثبت نشده'}
                                                </div>
                                            </div>
                                            <div className='col-12 col-md-4'>
                                                <div className="more-info-item">
                                                    <i className="bi bi-caret-left ms-1"></i>
                                                    <label> رشته :</label>
                                                    {this.state.personnel.major !== "" ? this.state.personnel.major : 'ثبت نشده'}
                                                </div>
                                            </div>
                                            <div className='col-12 col-md-4'>
                                                <div className="more-info-item">
                                                    <i className="bi bi-caret-left ms-1"></i>
                                                    <label> نوع :</label>
                                                    {this.state.personnelObject.type}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Tab>
                                <Tab eventKey="documents" title="مدارک" className='records'
                                     style={{backgroundColor: "transparent"}}>
                                    <div className="tabs-content">
                                        <Accordion>
                                            <Accordion.Item eventKey="0">
                                                <Accordion.Header>شناسنامه</Accordion.Header>
                                                <Accordion.Body>
                                                    <div className="d-flex flex-column">
                                                        {
                                                            this.state.hasBirthPage1 && (
                                                                <OverlayTrigger
                                                                    placement="bottom"
                                                                    overlay={
                                                                        <Tooltip className="deleteTooltip">
                                                                            دانلود
                                                                        </Tooltip>
                                                                    }
                                                                >
                                                                    <div className="record-item"
                                                                         onClick={() => {
                                                                             this.downloadFile(this.state.docFile.birthPage1)
                                                                             console.log(this.state.docFile)
                                                                         }}>
                                                                        <div className='ms-2'>صفحه اول</div>
                                                                        <RiDownloadCloud2Fill/>
                                                                    </div>
                                                                </OverlayTrigger>
                                                            )
                                                        }

                                                        {
                                                            this.state.hasBirthPage2 && (
                                                                <OverlayTrigger
                                                                    placement="bottom"
                                                                    overlay={
                                                                        <Tooltip className="deleteTooltip">
                                                                            دانلود
                                                                        </Tooltip>
                                                                    }
                                                                >
                                                                    <div className="record-item"
                                                                         onClick={() => this.downloadFile(this.state.docFile.birthPage2)}>
                                                                        <div className='ms-2'>صفحه دوم</div>
                                                                        <RiDownloadCloud2Fill/>
                                                                    </div>
                                                                </OverlayTrigger>
                                                            )
                                                        }
                                                        {
                                                            this.state.hasBirthPage3 && (
                                                                <OverlayTrigger
                                                                    placement="bottom"
                                                                    overlay={
                                                                        <Tooltip className="deleteTooltip">
                                                                            دانلود
                                                                        </Tooltip>
                                                                    }
                                                                >
                                                                    <div className="record-item"
                                                                         onClick={() => this.downloadFile(this.state.docFile.birthPage3)}>
                                                                        <div className='ms-2'>صفحه سوم</div>
                                                                        <RiDownloadCloud2Fill/>
                                                                    </div>
                                                                </OverlayTrigger>
                                                            )
                                                        }
                                                        {
                                                            this.state.hasBirthPage4 && (
                                                                <OverlayTrigger
                                                                    placement="bottom"
                                                                    overlay={
                                                                        <Tooltip className="deleteTooltip">
                                                                            دانلود
                                                                        </Tooltip>
                                                                    }
                                                                >
                                                                    <div className="record-item"
                                                                         onClick={() => this.downloadFile(this.state.docFile.birthPage4)}>
                                                                        <div className='ms-2'>صفحه چهارم</div>
                                                                        <RiDownloadCloud2Fill/>
                                                                    </div>
                                                                </OverlayTrigger>
                                                            )
                                                        }
                                                        {
                                                            this.state.hasBirthAllPage && (
                                                                <OverlayTrigger
                                                                    placement="bottom"
                                                                    overlay={
                                                                        <Tooltip className="deleteTooltip">
                                                                            دانلود
                                                                        </Tooltip>
                                                                    }
                                                                >
                                                                    <div className="record-item"
                                                                         onClick={() => this.downloadFile(this.state.docFile.birthAllPage)}>
                                                                        <div className='ms-2'>کل صفحات</div>
                                                                        <RiDownloadCloud2Fill/>
                                                                    </div>
                                                                </OverlayTrigger>
                                                            )
                                                        }
                                                    </div>
                                                </Accordion.Body>
                                            </Accordion.Item>
                                            <Accordion.Item eventKey="1">
                                                <Accordion.Header>کارت ملی</Accordion.Header>
                                                <Accordion.Body>
                                                    {
                                                        this.state.hasCartPage1 && (
                                                            <OverlayTrigger
                                                                placement="bottom"
                                                                overlay={
                                                                    <Tooltip className="deleteTooltip">
                                                                        دانلود
                                                                    </Tooltip>
                                                                }
                                                            >
                                                                <div className="record-item"
                                                                     onClick={() => this.downloadFile(this.state.docFile.cardPage1)}>
                                                                    <div className='ms-2'>صفحه اول</div>
                                                                    <RiDownloadCloud2Fill/>
                                                                </div>
                                                            </OverlayTrigger>
                                                        )
                                                    }
                                                    {
                                                        this.state.hasCartPage2 && (
                                                            <OverlayTrigger
                                                                placement="bottom"
                                                                overlay={
                                                                    <Tooltip className="deleteTooltip">
                                                                        دانلود
                                                                    </Tooltip>
                                                                }
                                                            >
                                                                <div className="record-item"
                                                                     onClick={() => this.downloadFile(this.state.docFile.cardPage2)}>
                                                                    <div className='ms-2'>صفحه دوم</div>
                                                                    <RiDownloadCloud2Fill/>
                                                                </div>
                                                            </OverlayTrigger>
                                                        )
                                                    }
                                                    {
                                                        this.state.hasCartAllPage && (
                                                            <OverlayTrigger
                                                                placement="bottom"
                                                                overlay={
                                                                    <Tooltip className="deleteTooltip">
                                                                        دانلود
                                                                    </Tooltip>
                                                                }
                                                            >
                                                                <div className="record-item"
                                                                     onClick={() => this.downloadFile(this.state.docFile.cardAllPage)}>
                                                                    <div className='ms-2'>کل صفحات</div>
                                                                    <RiDownloadCloud2Fill/>
                                                                </div>
                                                            </OverlayTrigger>
                                                        )
                                                    }
                                                </Accordion.Body>
                                            </Accordion.Item>

                                            <Accordion.Item eventKey="2">
                                                <Accordion.Header>عکس پرسنلی</Accordion.Header>
                                                <Accordion.Body>
                                                    {
                                                        this.state.hasPersonnelImg && (
                                                            <OverlayTrigger
                                                                placement="bottom"
                                                                overlay={
                                                                    <Tooltip className="deleteTooltip">
                                                                        دانلود
                                                                    </Tooltip>
                                                                }
                                                            >
                                                                <div className="record-item"
                                                                     onClick={() => this.downloadFile(this.state.docFile.personnelImg)}>
                                                                    <div className='ms-2'>عکس پرسنلی</div>
                                                                    <RiDownloadCloud2Fill/>
                                                                </div>
                                                            </OverlayTrigger>
                                                        )
                                                    }
                                                </Accordion.Body>
                                            </Accordion.Item>
                                            <Accordion.Item eventKey="3">
                                                <Accordion.Header>فرم قرارداد</Accordion.Header>
                                                <Accordion.Body>
                                                    {
                                                        this.state.hasRegister && (
                                                            <OverlayTrigger
                                                                placement="bottom"
                                                                overlay={
                                                                    <Tooltip className="deleteTooltip">
                                                                        دانلود
                                                                    </Tooltip>
                                                                }
                                                            >
                                                                <div className="record-item"
                                                                     onClick={() => this.downloadFile(this.state.docFile.register)}>
                                                                    <div className="ms-2">فرم قرارداد</div>
                                                                    <RiDownloadCloud2Fill/>
                                                                </div>
                                                            </OverlayTrigger>
                                                        )
                                                    }
                                                </Accordion.Body>
                                            </Accordion.Item>
                                        </Accordion>
                                    </div>
                                </Tab>
                                <Tab eventKey="personnel-edit" title="ویرایش مشخصات"
                                     style={{backgroundColor: "transparent"}}>
                                    <div className="tabs-content">
                                        <p className="text-muted small">ویرایش اطلاعات پرسنل — بدون نام کاربری یا گذرواژه.</p>
                                        <div className="row g-2">
                                            {[
                                                ['firstName', 'نام'], ['lastName', 'نام خانوادگی'], ['fatherName', 'نام پدر'],
                                                ['nationalCode', 'کد ملی'], ['placeOfIssue', 'محل صدور'], ['phoneNumber', 'شماره تماس'],
                                                ['telephoneNumber', 'تلفن ثابت'], ['address', 'آدرس'],
                                            ].map(([field, label]) => (
                                                <div className="col-12 col-md-4" key={field}>
                                                    <label className="form-label small">{label}</label>
                                                    <input className="form-control form-control-sm"
                                                           value={this.state.editDraft[field] || ''}
                                                           maxLength={field.includes('phone') || field === 'nationalCode' ? (field === 'nationalCode' ? 10 : 11) : undefined}
                                                           onChange={(e) => this.setState({
                                                               editDraft: {...this.state.editDraft, [field]: e.target.value}
                                                           })}/>
                                                </div>
                                            ))}
                                        </div>
                                        <button type="button" className="btn-done mt-3" disabled={this.state.editSaving}
                                                onClick={this.savePersonnelEdit}>ذخیره تغییرات</button>
                                    </div>
                                </Tab>
                                <Tab eventKey="personnel-history" title="سوابق حضور"
                                     style={{backgroundColor: "transparent"}}>
                                    <div className="tabs-content">
                                        <div className="row g-2 mb-3">
                                            <div className="col-md-4">
                                                <select className="form-select form-select-sm"
                                                        value={this.state.historyRecordType}
                                                        onChange={(e) => this.setState({historyRecordType: e.target.value})}>
                                                    <option value="personnelEntry">زمان ورود</option>
                                                    <option value="personnelExit">زمان خروج</option>
                                                    <option value="contractCancel">لغو قرارداد</option>
                                                </select>
                                            </div>
                                            <div className="col-md-4">
                                                <input className="form-control form-control-sm" placeholder="تاریخ (مثلاً 1403/01/01)"
                                                       value={this.state.historyDate}
                                                       onChange={(e) => this.setState({historyDate: e.target.value})}/>
                                            </div>
                                            <div className="col-md-4">
                                                <input className="form-control form-control-sm" placeholder="توضیحات"
                                                       value={this.state.historyDescription}
                                                       onChange={(e) => this.setState({historyDescription: e.target.value})}/>
                                            </div>
                                        </div>
                                        <button type="button" className="btn-done btn-sm mb-3" onClick={this.addPersonnelHistory}>ثبت سابقه</button>
                                        <table className="table table-sm">
                                            <thead>
                                            <tr><th>نوع</th><th>تاریخ</th><th>توضیحات</th></tr>
                                            </thead>
                                            <tbody>
                                            {(this.state.personnelHistory || []).map((r) => (
                                                <tr key={r.id}>
                                                    <td>{this.historyTitleLabel(r.title)}</td>
                                                    <td>{r.date}</td>
                                                    <td>{r.description}</td>
                                                </tr>
                                            ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </Tab>
                                <Tab eventKey="work-reports" title="گزارش کار"
                                     style={{backgroundColor: "transparent"}}>
                                    <div className="tabs-content">
                                        <div className="mb-3">
                                            <div className="mb-2">
                                                <DatePicker
                                                    calendarPosition="bottom"
                                                    digits={['0', '1', '2', '3', '4', '5', '6', '7', '8', '9']}
                                                    format="YYYY/MM/DD"
                                                    inputClass="form-control"
                                                    containerStyle={{width: "100%"}}
                                                    portal
                                                    zIndex={10000}
                                                    value={this.state.workReportDate}
                                                    onChange={(value) => this.setState({workReportDate: value})}
                                                    calendar={persian}
                                                    locale={persian_fa}
                                                />
                                                <div className="form-text">تاریخ گزارش (شمسی)</div>
                                            </div>
                                            <textarea
                                                className="form-control mb-2"
                                                rows={3}
                                                placeholder="شرح گزارش کار روزانه"
                                                value={this.state.workReportText}
                                                onChange={(e) => this.setState({workReportText: e.target.value})}
                                            />
                                            <button
                                                className="btn-done"
                                                disabled={this.state.workReportLoading}
                                                onClick={this.submitWorkReport}
                                            >
                                                {this.state.editingWorkTask ? 'ذخیره ویرایش' : 'ثبت گزارش کار'}
                                            </button>
                                            {this.state.editingWorkTask ? (
                                                <button
                                                    type="button"
                                                    className="btn btn-light btn-sm me-2"
                                                    onClick={() => this.setState({
                                                        editingWorkTask: null,
                                                        workReportText: '',
                                                        workReportDate: '',
                                                    })}
                                                >انصراف</button>
                                            ) : null}
                                        </div>
                                        <table className="table">
                                            <thead>
                                            <tr>
                                                <th>تاریخ</th>
                                                <th>شرح</th>
                                                <th>عملیات</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {(this.state.workTasks || []).map((t) => (
                                                <tr key={t.id}>
                                                    <td>{(t.dueDate || '').split(' ')[0]}</td>
                                                    <td>{t.description || t.name}</td>
                                                    <td>
                                                        <button type="button" className="btn btn-sm btn-outline-primary me-1"
                                                                onClick={() => this.setState({
                                                                    editingWorkTask: t,
                                                                    workReportText: t.description || '',
                                                                    workReportDate: (t.dueDate || '').split(' ')[0],
                                                                })}>ویرایش</button>
                                                        <button type="button" className="btn btn-sm btn-outline-danger"
                                                                onClick={() => this.deleteWorkReport(t.id)}>حذف</button>
                                                    </td>
                                                </tr>
                                            ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </Tab>
                            </Tabs>
                        </div>
                    </div>
                </div>
            </>
        );
    }

    historyTitleLabel = (title) => ({
        personnelEntry: 'ورود',
        personnelExit: 'خروج',
        contractCancel: 'لغو قرارداد',
    }[title] || title);

    loadPersonnelHistory = async (personnelId) => {
        if (!personnelId) return;
        try {
            const data = await axios.get(`${API_BASE_URL}/api/v1/supervisor/record/search`, {
                headers: {'Authorization': localStorage.getItem('accessToken')},
                params: {personnelId},
            }).then(r => r.data);
            this.setState({
                personnelHistory: Array.isArray(data) ? data : [],
                editDraft: {...this.state.personnel},
            });
        } catch (e) {
            this.setState({personnelHistory: [], editDraft: {...this.state.personnel}});
        }
    }

    addPersonnelHistory = async () => {
        const personnelId = this.state.personnelObject?.id;
        const date = (this.state.historyDate || '').trim();
        if (!personnelId || !date) {
            window.alert('تاریخ را وارد کنید');
            return;
        }
        await axios.post(`${API_BASE_URL}/api/v1/supervisor/record`, {
            title: this.state.historyRecordType,
            date,
            description: this.state.historyDescription,
            personnelId,
        }, {headers: {'Authorization': localStorage.getItem('accessToken')}});
        this.setState({historyDate: '', historyDescription: ''});
        await this.loadPersonnelHistory(personnelId);
    }

    savePersonnelEdit = async () => {
        const charId = this.state.personnel?.id;
        if (!charId) return;
        this.setState({editSaving: true});
        try {
            await axios.put(`${API_BASE_URL}/api/v1/supervisor/characteristic/${charId}`, this.state.editDraft, {
                headers: {'Authorization': localStorage.getItem('accessToken')}
            });
            const data = await axios.get(`${API_BASE_URL}/api/v1/supervisor/characteristic/${charId}`, {
                headers: {'Authorization': localStorage.getItem('accessToken')}
            }).then(r => r.data);
            this.setState({personnel: data, editDraft: {...data}});
            window.alert('ذخیره شد');
        } catch (e) {
            window.alert('ذخیره ناموفق بود');
        } finally {
            this.setState({editSaving: false});
        }
    }

    loadWorkTasks = async (personnelId) => {
        if (!personnelId) {
            return;
        }
        try {
            const data = await axios.get(`${API_BASE_URL}/api/v1/supervisor/task/search`, {
                headers: {'Authorization': localStorage.getItem('accessToken')},
                params: {personnelId, name: 'گزارش کار روزانه'},
            }).then(r => r.data);
            this.setState({workTasks: Array.isArray(data) ? data : []});
        } catch (e) {
            this.setState({workTasks: []});
        }
    }

    submitWorkReport = async () => {
        const description = (this.state.workReportText || '').trim();
        const personnelId = this.state.personnelObject?.id;
        if (!description || !personnelId) {
            return;
        }
        this.setState({workReportLoading: true});
        const jalaliDate = formatDateObject(this.state.workReportDate)
            || new Date().toLocaleDateString('fa-IR-u-nu-latn', {
                year: 'numeric', month: '2-digit', day: '2-digit', formatMatcher: 'basic'
            });
        const payload = {
            name: 'گزارش کار روزانه',
            description,
            dueDate: `${jalaliDate} 00:00:00`,
            priority: 'medium',
            status: 'done',
            personnelId,
            fullName: `${this.state.personnel.firstName || ''} ${this.state.personnel.lastName || ''}`.trim(),
        };
        try {
            if (this.state.editingWorkTask?.id) {
                await axios.put(`${API_BASE_URL}/api/v1/supervisor/task/${this.state.editingWorkTask.id}`, payload, {
                    headers: {'Authorization': localStorage.getItem('accessToken')}
                });
            } else {
                await axios.post(`${API_BASE_URL}/api/v1/supervisor/task`, payload, {
                    headers: {'Authorization': localStorage.getItem('accessToken')}
                });
            }
            this.setState({
                workReportText: '',
                workReportDate: '',
                workReportLoading: false,
                editingWorkTask: null,
            });
            await this.loadWorkTasks(personnelId);
        } catch (e) {
            this.setState({workReportLoading: false});
            window.alert('ثبت گزارش کار ناموفق بود');
        }
    }

    deleteWorkReport = async (taskId) => {
        if (!taskId || !window.confirm('حذف این گزارش کار؟')) {
            return;
        }
        try {
            await axios.delete(`${API_BASE_URL}/api/v1/supervisor/task/${taskId}`, {
                headers: {'Authorization': localStorage.getItem('accessToken')}
            });
            await this.loadWorkTasks(this.state.personnelObject?.id);
        } catch (e) {
            window.alert('حذف گزارش کار ناموفق بود');
        }
    }

    downloadFile = async (fId) => {
        const file = this.state.fileDetails.find(({fileId}) => fId === fileId);
        var filename = file.originalName;

        axios.get(API_BASE_URL + "/api/v1/supervisor/file/" + fId, {responseType: "blob", headers: {Authorization: localStorage.getItem("accessToken")}}).then(response => response.data)
            .then((blob) => {

                console.log('blob')
                console.log(blob)

                if (blob !== null) {
                    var url = window.URL.createObjectURL(blob);
                    var a = document.createElement('a');
                    a.href = url;
                    a.download = filename;
                    document.body.appendChild(a);
                    a.click();
                    a.remove();
                }
            }).catch(() => {
            if (localStorage.getItem('role') === 'MANAGER') {
                axios.get(`${API_BASE_URL}/api/v1/manager/token/refresh`, {headers: {'Authorization': localStorage.getItem('refreshToken')}})
                    .then((response) => {
                        if (response.headers["accesstoken"]) {
                            localStorage.setItem("accessToken", response.headers["accesstoken"]);
                            axios.get(API_BASE_URL + "/api/v1/supervisor/file/" + fId, {responseType: "blob", headers: {Authorization: localStorage.getItem("accessToken")}}).then(response => response.data)
                                .then((blob) => {
                                    if (blob !== null) {
                                        var url = window.URL.createObjectURL(blob);
                                        var a = document.createElement('a');
                                        a.href = url;
                                        a.download = filename;
                                        document.body.appendChild(a);
                                        a.click();
                                        a.remove();
                                    }
                                });
                        } else {
                            window.location = '/'
                        }
                    })
            } else if (localStorage.getItem('role') === 'SUPERVISOR') {
                axios.get(`${API_BASE_URL}/api/v1/supervisor/token/refresh`, {headers: {'Authorization': localStorage.getItem('refreshToken')}})
                    .then((response) => {
                        if (response.headers["accesstoken"]) {
                            localStorage.setItem("accessToken", response.headers["accesstoken"]);
                            axios.get(API_BASE_URL + "/api/v1/supervisor/file/" + fId, {responseType: "blob", headers: {Authorization: localStorage.getItem("accessToken")}}).then(response => response.data)
                                .then((blob) => {
                                    if (blob !== null) {
                                        var url = window.URL.createObjectURL(blob);
                                        var a = document.createElement('a');
                                        a.href = url;
                                        a.download = filename;
                                        document.body.appendChild(a);
                                        a.click();
                                        a.remove();
                                    }
                                });
                        } else {
                            window.location = '/'
                        }
                    })
            }
        })
    }

    existDocFile = (docFile) => {
        if (docFile.hasOwnProperty('birthPage1')) {
            this.setState({hasBirthPage1: true});
        }
        if (docFile.hasOwnProperty('birthPage2')) {
            this.setState({hasBirthPage2: true});
        }
        if (docFile.hasOwnProperty('birthPage3')) {
            this.setState({hasBirthPage3: true});
        }
        if (docFile.hasOwnProperty('birthPage4')) {
            this.setState({hasBirthPage4: true});
        }
        if (docFile.hasOwnProperty('birthAllPage')) {
            this.setState({hasBirthAllPage: true});
        }
        if (docFile.hasOwnProperty('cardPage1')) {
            this.setState({hasCartPage1: true});
        }
        if (docFile.hasOwnProperty('cardPage2')) {
            this.setState({hasCartPage2: true});
        }
        if (docFile.hasOwnProperty('cardAllPage')) {
            this.setState({hasCartAllPage: true});
        }
        if (docFile.hasOwnProperty('personnelImg')) {
            this.setState({hasPersonnelImg: true});
        }
        if (docFile.hasOwnProperty('register')) {
            this.setState({hasRegister: true});
        }
    }
}


export default PersonnelProfilePage
